import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function ImpersonatePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const userData = searchParams.get('user');
    
    if (token && userData) {
      try {
        // Store with correct keys matching AuthContext
        localStorage.setItem('cts_token', token);
        localStorage.setItem('cts_user', userData);
        
        // Redirect to admin panel (index route = dashboard)
        window.location.href = '/admin';
      } catch (err) {
        console.error('Impersonation failed:', err);
        navigate('/login');
      }
    } else {
      navigate('/login');
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#E31937] mx-auto mb-4"></div>
        <p className="text-gray-600">Switching to staff view...</p>
      </div>
    </div>
  );
}
